/**
 * Val's Tools & AW Apparel - Premium Implementation
 * Custom JS for UI interactions, Sliders, and Animations
 */

document.addEventListener("DOMContentLoaded", () => {
    
    // ==========================================================================
    // 1. GLOBAL INITIALIZATION & REVEAL ANIMATIONS
    // ==========================================================================
    
    // Remove the loading class after a brief delay to trigger CSS transitions
    setTimeout(() => {
        document.body.classList.remove('loading');
    }, 150);


    // ==========================================================================
    // 2. MOBILE MENU OVERLAY HANDLING
    // ==========================================================================
    
    const openMenuBtn = document.getElementById('awOpenMenu');
    const closeMenuBtn = document.getElementById('awCloseMenu');
    const mobileMenu = document.getElementById('awMobileMenu');

    if (openMenuBtn && closeMenuBtn && mobileMenu) {
        // Open Menu
        openMenuBtn.addEventListener('click', () => {
            mobileMenu.classList.add('active');
            mobileMenu.setAttribute('aria-hidden', 'false');
            document.body.style.overflow = 'hidden'; // Lock background scroll
        });

        // Close Menu
        closeMenuBtn.addEventListener('click', () => {
            mobileMenu.classList.remove('active');
            mobileMenu.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = ''; // Restore background scroll
        });

        // Close menu automatically when clicking a navigation link
        document.querySelectorAll('.menu-content a').forEach(link => {
            link.addEventListener('click', () => {
                mobileMenu.classList.remove('active');
                mobileMenu.setAttribute('aria-hidden', 'true');
                document.body.style.overflow = '';
            });
        });
    }

// ==========================================================================
// 3. SPLIDE.JS SLIDER INITIALIZATIONS
// ==========================================================================

// A. Hot Video Deals Slider (Center focus with scaling CSS)

window.addEventListener('load', () => {

    const videoDealsSlider = document.getElementById('vSlider');

    if (videoDealsSlider) {

        const vSplide = new Splide(videoDealsSlider, {
            type        : 'loop',

            perPage     : 5,
            perMove     : 1,

            focus       : 'center',
            gap         : '30px',

            arrows      : false,
            pagination  : false,

            speed       : 1000,
            easing      : 'cubic-bezier(0.25, 1, 0.5, 1)',

            // Autoplay
            autoplay    : true,
            interval    : 3000,
            pauseOnHover: false,
            pauseOnFocus: false,

            // Disable manual interactions
            drag        : false,
            wheel       : false,
            keyboard    : false,
            touchMove   : false,

            // Prevent initial broken sizing
            updateOnMove: true,

            breakpoints : {

                1400: {
                    perPage: 4
                },

                1100: {
                    perPage: 3
                },

                768 : {
                    perPage : 1,
                    gap     : '20px',

                    padding : {
                        left  : '22%',
                        right : '22%'
                    }
                }
            }
        });

        vSplide.mount();

        // Fix initial cut / incorrect width issue
        setTimeout(() => {
            vSplide.refresh();
        }, 150);

        // Custom Arrow Buttons
        document.getElementById('vPrev')
            ?.addEventListener('click', () => vSplide.go('<'));

        document.getElementById('vNext')
            ?.addEventListener('click', () => vSplide.go('>'));
    }

});

    // B. Shop By Brand Slider (Converts to CSS Grid on mobile)
    // const brandSlider = document.getElementById('brandSlider');
    // if (brandSlider) {
    //     new Splide(brandSlider, {
    //         type       : 'slide',
    //         perPage    : 4,
    //         gap        : '25px',
    //         arrows     : true,
    //         pagination : false,
    //         breakpoints: {
    //             1024: { perPage: 3 },
    //             768 : { destroy: true } // Kills Splide entirely so the 2x2 CSS Grid takes over
    //         }
    //     }).mount();
    // }

   // C. Top Sellers Sliders (Inside Bootstrap Tabs)

const topSellerConfig = {
    type        : 'slide',
    perPage     : 4,
    gap         : '10px',

    // Desktop OFF
    arrows      : false,

    pagination  : false,

    breakpoints : {

        1400: {
            perPage : 2,
            arrows  : false
        },

        991: {
            perPage : 2,
            arrows  : false
        },

        // Mobile
        768: {
            perPage : 1,
            gap     : '15px',

            // Mobile arrows ON
            arrows  : true,

            // IMPORTANT:
            // Remove padding so only 1 slide shows
            padding : 0
        }
    }
};

// Mount individual instances
const splideValElem = document.getElementById('splideVal');
const splideAwElem  = document.getElementById('splideAw');

let tsSplideVal, tsSplideAw;

if (splideValElem) {
    tsSplideVal = new Splide(splideValElem, topSellerConfig);
    tsSplideVal.mount();
}

if (splideAwElem) {
    tsSplideAw = new Splide(splideAwElem, topSellerConfig);
    tsSplideAw.mount();
}

// Fix hidden Bootstrap tab width issue
document.querySelectorAll('.ts-tabs .nav-link').forEach(btn => {

    btn.addEventListener('shown.bs.tab', () => {

        tsSplideVal?.refresh();
        tsSplideAw?.refresh();

        window.dispatchEvent(new Event('resize'));

    });

});

  const reviewsSlider = document.getElementById('reviewsSlider');

if (reviewsSlider) {

    new Splide(reviewsSlider, {
        type        : 'slide',

        perPage     : 2.2,
        gap         : '0px',

        focus       : 0,

        arrows      : true,
        pagination  : false,

        breakpoints : {

            1400: { perPage: 1.8 },

            1024: { perPage: 1.4 },

            991 : { perPage: 1.2 },

            768 : {
                perPage : 1,
                padding : {
                    right : '10%'
                }
            }
        }

    }).mount();
}
// E. Posters Slider
    const postersSlider = document.getElementById('postersSlider');
    if (postersSlider) {
        new Splide(postersSlider, {
            type       : 'loop',   // 'loop' makes it infinitely scrollable
            perPage    : 4,
            gap        : '15px',
            arrows     : false,
            pagination : false,
            drag       : true,     // Standard drag works best for mobile
            swipe      : true,
            breakpoints: {
                1200: { 
                    perPage: 3 
                },
                991 : { 
                    perPage: 2.3 
                },
                768 : { 
                    perPage: 1.2, 
                    padding: { right: '10%' } // Gives a peek at the next card
                }
            }
        }).mount();
    }
   // F. Latest Videos Slider (Center focus)

window.addEventListener('load', () => {

    const latestVideos = document.getElementById('latestVideosSlider');

    if (latestVideos) {

        const lvSplide = new Splide(latestVideos, {
            type        : 'loop',
            perPage     : 3,
            perMove     : 1,

            focus       : 'center',
            gap         : '40px',

            arrows      : false, // Using custom buttons
            pagination  : false,

            autoplay    : true,
            interval    : 3500,

            speed       : 1000,
            easing      : 'cubic-bezier(0.25, 1, 0.5, 1)',

            // Disable manual interactions
            drag        : false,
            wheel       : false,
            keyboard    : false,
            touchMove   : false,

            breakpoints : {
                1024: {
                    perPage : 2,
                    focus   : 0,
                    gap     : '20px'
                },

                768 : {
                    perPage : 1,
                    focus   : 'center',
                    gap     : '15px',

                    padding : {
                        left  : '15%',
                        right : '15%'
                    }
                }
            }
        });

        lvSplide.mount();

        // Prevent initial broken/cut layout
        setTimeout(() => {
            lvSplide.refresh();
        }, 100);

        // Custom Bottom Buttons
        document.querySelector('.lv-prev')
            ?.addEventListener('click', () => lvSplide.go('<'));

        document.querySelector('.lv-next')
            ?.addEventListener('click', () => lvSplide.go('>'));
    }

});



    // ==========================================================================
    // 4. OPTIONAL: SUBTLE PARALLAX ON HERO SPLIT PANES (DESKTOP ONLY)
    // ==========================================================================
    if (window.innerWidth > 992) {
        const panes = document.querySelectorAll('.split-pane');
        panes.forEach(pane => {
            pane.addEventListener('mousemove', (e) => {
                const bg = pane.querySelector('.bg-image');
                if(!bg) return;
                
                // Calculate position relative to the center of the pane
                const rect = pane.getBoundingClientRect();
                const x = e.clientX - rect.left - (rect.width / 2);
                const y = e.clientY - rect.top - (rect.height / 2);
                
                // Move background slightly in the opposite direction
                bg.style.transform = `scale(1.08) translate(${x * -0.015}px, ${y * -0.015}px)`;
            });

            // Reset when mouse leaves
            pane.addEventListener('mouseleave', () => {
                const bg = pane.querySelector('.bg-image');
                if(bg) bg.style.transform = 'scale(1)';
            });
        });
    }

});



// Sticky Header Effect

const header = document.querySelector('.desktop-header-wrap');

window.addEventListener('scroll', () => {

    if (window.scrollY > 40) {
        header.classList.add('sticky-active');
    } else {
        header.classList.remove('sticky-active');
    }

});




// For shop page 

document.addEventListener("DOMContentLoaded", () => {
    // 1. Dual Range Slider Pricing Logic
    const minRange = document.querySelector(".min-r");
    const maxRange = document.querySelector(".max-r");
    const priceInputs = document.querySelectorAll(".price-inp input");

    function updateRange() {
        if (parseInt(minRange.value) > parseInt(maxRange.value)) {
            minRange.value = maxRange.value;
        }
        priceInputs[0].value = minRange.value;
        priceInputs[1].value = maxRange.value;
    }

    minRange?.addEventListener("input", updateRange);
    maxRange?.addEventListener("input", updateRange);

    // 2. Clear All Logic
    document.querySelector(".clear-all-btn")?.addEventListener("click", () => {
        document.querySelectorAll('.filter-ui-dropdown input[type="checkbox"]').forEach(c => c.checked = false);
    });
});
// Cart badges render server-side, so an AJAX add leaves every header count stale.
// They are always in the DOM and carry d-none at zero, so this only writes and toggles.
window.awSetCartCount = function (count) {
    document.querySelectorAll('.aw-cart-count').forEach(function (badge) {
        badge.textContent = count;
        badge.classList.toggle('d-none', !count);
    });
};

// For callers whose response carries the changed lines rather than the whole cart.
window.awRefreshCartCount = function () {
    return fetch(window.Shopify.routes.root + 'cart.js')
        .then(function (response) { return response.json(); })
        .then(function (cart) { window.awSetCartCount(cart.item_count); })
        .catch(function (error) { console.error('Error refreshing cart count:', error); });
};

// Mobile header is a fixed purple bar that stays at the top so menu, search and cart
// are always one tap away. This keeps the page padded by its height.
(function () {
    var header = document.querySelector('.mobile-header');
    if (!header) return;

    var MOBILE_MAX = 991.98;

    function isMobile() { return window.innerWidth <= MOBILE_MAX; }

    // The header is now a solid bar on every page (home included), so the page always
    // starts below it. It stays put while scrolling; it no longer tucks away.
    function measure() {
        document.documentElement.style.setProperty('--aw-mobile-header-height', header.offsetHeight + 'px');
        document.body.classList.toggle('aw-mobile-header-offset', isMobile());
    }

    measure();
    window.addEventListener('resize', measure);
    // The logo image and web font can change the header height after load.
    window.addEventListener('load', measure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
})();
